import { makeAutoObservable } from 'mobx';

import { formatMsgTime } from 'utils/formatMsgTime';

import { DEFAULT_POSITION, INITIAL_MESSAGES } from './const';

class BuddyStore {
	isOpen = false;
	position = DEFAULT_POSITION;
	messages = INITIAL_MESSAGES;
	isLoading = false;

	constructor() {
		makeAutoObservable(this);
	}

	setOpen = (value) => {
		this.isOpen = value;
	};

	toggleOpen = () => {
		this.isOpen = !this.isOpen;
	};

	setPosition = ({ x, y }) => {
		this.position = { x, y };
	};

	addUserMessage = (text) => {
		const ts = Date.now();
		this.messages.push({ id: `user-${ts}`, role: 'user', text, time: formatMsgTime(ts) });
	};

	addAssistantMessage = (text, card) => {
		const ts = Date.now();
		this.messages.push({ id: `bot-${ts}`, role: 'assistant', text, card, time: formatMsgTime(ts) });
	};

	setLoading = (value) => {
		this.isLoading = value;
	};

	setMessages = (messages) => {
		this.messages = messages;
	};

	clearMessages = () => {
		this.messages = INITIAL_MESSAGES;
	};
}

export const buddyStore = new BuddyStore();
